import React from 'react';

import { Grid, Section, Alert } from '@gogame/components';

export const TargetingSection = ({
  affiliate,
  application,
  network,
  platform,
  domain,
  locale,
  conversionPageFlows,
  conversionPages,
  country,
  activityType,
  mediaSource,
}) => {
  return (
    <Section title={'Targeting'}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          {application}
        </Grid>
        <Grid item xs={4}>
          {network}
        </Grid>
        <Grid item xs={4}>
          {affiliate}
        </Grid>
        <Grid item xs={4}>
          {platform}
        </Grid>
        {domain ? (
          <Grid item xs={4}>
            {domain}
          </Grid>
        ) : null}
        {locale ? (
          <Grid item xs={2}>
            {locale}
          </Grid>
        ) : null}
        {conversionPageFlows ? (
          <Grid item xs={2}>
            {conversionPageFlows}
          </Grid>
        ) : null}
        {conversionPages ? (
          <Grid item xs={8}>
            {conversionPages}
          </Grid>
        ) : null}
        <Grid item xs={4}>
          {country}
        </Grid>

        <Grid item xs={12}>
          {activityType}
        </Grid>
        {mediaSource ? (
          <Grid item container spacing={3}>
            <Grid item xs={12}>
              <Alert severity={'warning'}>
                The selected affiliate doesn’t have an AppsFlyer media source
                yet. Add media source for using affiliate in campaigns.
              </Alert>
            </Grid>
            <Grid item xs={4}>
              {mediaSource}
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </Section>
  );
};
